module.exports = {
  returnNameForId: {
    1: 'Validacao',
    2: 'Processamento',
  },
  returnIdForName: {
    Validacao: 1,
    Processamento: 2,
  },
};
